import { fromJS } from 'immutable';
import { ADD, SET, CLEAR, UPDATE, CLIP } from './constants';

const initialState = fromJS({
  coursewareItems: [],
  clipboard: [],
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD:
      return state.updateIn(
        ['coursewareItems'],
        (arr) => (arr.push(action.data))
      );
    case SET:
      return state.set(
        'coursewareItems',
        fromJS([])
      )
        .set('coursewareItems', fromJS([action.data]));
    case CLEAR:
      return state.set(
        'coursewareItems',
        fromJS([])
      );
    case UPDATE:
      return state.set(
        'coursewareItems',
        fromJS(action.data)
      );
    case CLIP:
      return state.set('clipboard', fromJS(action.data));
    default:
      return state;
  }
};

export default reducer;
